module.exports = __webpack_public_path__ + "img/PL09430.ea33c7ae.png";